import React from "react";

interface ContentProps {
  children: React.ReactNode;
}

export function Content(props: ContentProps) {
  const { children } = props;

  return <div className="content">{children}</div>;
}
